/*
 * Public API Surface of jointc2-angular-configuration
 */

import { InjectionToken, Type } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { Jc2Config } from "./config.model";

declare global {
  interface Window {
    JC2_CONFIG_VALUE: Jc2Config;
  }

  // Declare as var, because the lib gets imported multiple times in the test repo
  // eslint-disable-next-line no-var
  var JC2_CONFIG_VALUE: Jc2Config;
}

type LoadChildrenCallback = () => Type<any> | Promise<Type<any>>;

export const JC2_CONFIG = new InjectionToken<Jc2Config>("JC2_CONFIG");

const fetchConfig = (url: string): Promise<Jc2Config | null> => {
  try {
    return fetch(url, { cache: "no-cache" }).then((r) => r.json());
  } catch (e) {
    alert(`Could not load the config from ${url}`);
    return Promise.resolve(null);
  }
};

const asyncWrapper = async (
  configURL: string,
  moduleImportCallback: LoadChildrenCallback,
) => {
  const config = await fetchConfig(configURL);
  if (!config) return;
  window.JC2_CONFIG_VALUE = config;

  const angularModule = await moduleImportCallback();
  platformBrowserDynamic([{ provide: JC2_CONFIG, useValue: config }])
    .bootstrapModule(angularModule)
    .catch(alert);
};

/**
 * Take an appModule and launch it with a value provider and a global variable which both provide the config value.
 * @param configURL The url of the config file
 * @param moduleImportCallback The import of the AppModule as typescript import expression import('./app/app.module')
 */
export const launchModuleWithConfig = (
  configURL: string,
  moduleImportCallback: LoadChildrenCallback,
): void => {
  asyncWrapper(configURL, moduleImportCallback).catch(() => {
    alert("Could not load app");
  });
};
